import React from 'react';
import UserTableActions from './UserTableActions';
import DynamicAppsTableActions from './DynamicAppsTableActions';

export const dynamicAppsColumns = [
    {
        name: 'Master App',
        selector: 'masterApp.title',
        width: '200px',
        wrap: true,
        sortable: true,
    },
    {
        name: 'Dynamic App',
        minWidth: '200px',
        wrap: true,
        selector: 'title',
        sortable: true,
    },
    {
        name: 'Qs App Id',
        selector: 'qsApp',
        minWidth: '200px',
        wrap: true,
        sortable: true,
    },
    {
        name: 'Users',
        sortable: false,
        width: '100px',
        // eslint-disable-next-line react/display-name
        cell: (row) => (
            <span>
                {row.users.length === 1
                    ? row.users[0].name
                    : row.users.length > 1
                    ? 'Multiple'
                    : row.users.length}
            </span>
        ),
    },
    {
        name: 'Actions',
        sortable: false,
        width: '150px',
        // eslint-disable-next-line react/display-name
        cell: (row) => (
            <DynamicAppsTableActions id={row._id} qsApp={row.qsApp} />
        ),
    },
];

export const userColumns = (handleDelete) => {
    return [
        {
            name: 'Name',
            selector: 'name',
            sortable: true,
        },
        {
            name: 'QS Directory',
            selector: 'directory',
            sortable: true,
        },
        {
            name: 'QS ID',
            selector: 'qsId',
            sortable: true,
        },
        {
            name: 'Email',
            selector: 'email',
            sortable: true,
        },
        {
            name: 'Actions',
            sortable: false,
            width: '350px',
            // eslint-disable-next-line react/display-name
            cell: (row) => (
                <UserTableActions
                    id={row._id}
                    handleDelete={() => handleDelete(row._id)}
                />
            ),
        },
    ];
};
